// // import React, { useMemo } from "react";
// import React, {
//   useMemo,
//   useState,
// } from "react";
// import { useParams } from "react-router-dom";
// import "../../css/ChartingSummary.css";
// import ToothSummaryCard from "./ToothSummaryCard";
// import api from "../../api/axiosConfig";
// import { ChartingState } from "../../pages/DentalChartingScreen";

// interface ChartingSummaryProps {
//   chartingData: ChartingState;
//   onSubmitSuccess: () => void; // ✅ NEW
// }

// // const ALL_TEETH_IDS = [
// //   55, 54, 53, 52, 51, 61, 62, 63, 64, 65, 85, 84, 83, 82, 81, 71, 72, 73, 74,
// //   75,
// // ];

// const TOOTH_ROWS = [
//   [55, 54, 53, 52, 51],
//   [61, 62, 63, 64, 65],
//   [85, 84, 83, 82, 81],
//   [71, 72, 73, 74, 75],
// ];

// const POPUP_ROWS = [
//   [
//     55,
//     54,
//     53,
//     52,
//     51,
//     61,
//     62,
//     63,
//     64,
//     65,
//   ],

//   [
//     85,
//     84,
//     83,
//     82,
//     81,
//     71,
//     72,
//     73,
//     74,
//     75,
//   ],
// ];

// const ChartingSummary: React.FC<ChartingSummaryProps> = ({
//   chartingData,
//   onSubmitSuccess,
// }) => {

//   const [showPopup, setShowPopup] =
//   useState(false);
//   const { emrNumber } = useParams<{ emrNumber: string }>();
//   const emrId = emrNumber;

//   const summaryData = useMemo(() => {
//     let activeLesions = 0;
//     const teethWithCaries = new Set<string>();

//     const codeCounts: {
//       restoration: Record<string, number>;
//       caries: Record<string, number>;
//       activity: Record<string, number>;
//       missing: Record<string, number>;
//     } = {
//       restoration: {
//         "0": 0,
//         "1": 0,
//         "2": 0,
//         "3": 0,
//         "4": 0,
//         "5": 0,
//         "6": 0,
//         "7": 0,
//         "8": 0,
//       },
//       caries: { "0": 0, "1": 0, "2": 0, "3": 0, "4": 0, "5": 0, "6": 0 },
//       activity: { "+": 0, "-": 0 },
//       missing: { "97": 0, "98": 0, "99": 0, P: 0 },
//     };

//     for (const toothId in chartingData) {
//       const tooth = chartingData[toothId];

//       if (tooth.isMissing) {
//         const code = tooth.missingCode || "P";
//         codeCounts.missing[code] = (codeCounts.missing[code] || 0) + 1;
//         continue;
//       }

//       for (const segment of Object.values(tooth.segments)) {
//         if (segment.activity) {
//           if (segment.activity === "+") activeLesions++;
//           codeCounts.activity[segment.activity] =
//             (codeCounts.activity[segment.activity] || 0) + 1;
//         }

//         if (segment.restoration) {
//           codeCounts.restoration[segment.restoration] =
//             (codeCounts.restoration[segment.restoration] || 0) + 1;
//         }

//         if (segment.caries) {
//           if (parseInt(segment.caries, 10) > 0) {
//             teethWithCaries.add(toothId);
//           }
//           codeCounts.caries[segment.caries] =
//             (codeCounts.caries[segment.caries] || 0) + 1;
//         }
//       }
//     }

//     return {
//       stats: {
//         assessed: Object.keys(chartingData).length,
//         activeLesions,
//         teethWithCaries: teethWithCaries.size,
//       },
//       counts: codeCounts,
//     };
//   }, [chartingData]);

//   const handleSubmit = async () => {
//     if (!emrId) {
//       alert("EMR ID missing");
//       return;
//     }

//     try {
//       await api.dataCollectionApi.post("/api/teledocs/dental/summary", {
//         patientId: emrId,
//         chartType: "primary",
//         createdBy: "doctor_123",
//         summaryData,
//       });

//       // ✅ MOVE TO TAB 3
//       onSubmitSuccess();
//     } catch (err) {
//       console.error("Failed to save dental summary:", err);
//       alert("Failed to save summary. Please try again.");
//     }
//   };

//   return (
//     <div className="summary-container">
//       <h2 className="summary-main-title">Online Charting Summary</h2>
//       <p className="summary-subtitle">
//         This summary is automatically prepared after the online dental chart is
//         submitted.
//       </p>

//       <div className="summary-legend-grid">
//         {/* Legends with blue summary numbers */}
//         <div className="legend-column restoration">
//           <h4>Presence of Restoration or Sealants</h4>
//           <ul>
//             <li>
//               <span>0</span> Not Restored or Sealed{" "}
//               <span className="code-count">
//                 {summaryData.counts.restoration["0"] || 0}
//               </span>
//             </li>
//             <li>
//               <span>1</span> Sealant Partial{" "}
//               <span className="code-count">
//                 {summaryData.counts.restoration["1"] || 0}
//               </span>
//             </li>
//             <li>
//               <span>2</span> Sealant Full{" "}
//               <span className="code-count">
//                 {summaryData.counts.restoration["2"] || 0}
//               </span>
//             </li>
//             <li>
//               <span>3</span> Tooth Coloured Restoration{" "}
//               <span className="code-count">
//                 {summaryData.counts.restoration["3"] || 0}
//               </span>
//             </li>
//             <li>
//               <span>4</span> Amalgam Restoration{" "}
//               <span className="code-count">
//                 {summaryData.counts.restoration["4"] || 0}
//               </span>
//             </li>
//             <li>
//               <span>5</span> Stainless steel Crown{" "}
//               <span className="code-count">
//                 {summaryData.counts.restoration["5"] || 0}
//               </span>
//             </li>
//             <li>
//               <span>6</span> Porcelain | Gold | etc.{" "}
//               <span className="code-count">
//                 {summaryData.counts.restoration["6"] || 0}
//               </span>
//             </li>
//             <li>
//               <span>7</span> Lost or Broken Restoration{" "}
//               <span className="code-count">
//                 {summaryData.counts.restoration["7"] || 0}
//               </span>
//             </li>
//             <li>
//               <span>8</span> Temporary Restoration{" "}
//               <span className="code-count">
//                 {summaryData.counts.restoration["8"] || 0}
//               </span>
//             </li>
//           </ul>
//         </div>
//         <div className="legend-column caries">
//           <h4>Presence and Severity of Caries Lesions</h4>
//           <p>
//             <strong>Sound Surface</strong>
//           </p>
//           <ul>
//             <li>
//               <span>0</span> No evidence of caries{" "}
//               <span className="code-count">
//                 {summaryData.counts.caries["0"] || 0}
//               </span>
//             </li>
//           </ul>
//           <p>
//             <strong>Initial Caries</strong>
//           </p>
//           <ul>
//             <li>
//               <span>1</span> Initial Caries{" "}
//               <span className="code-count">
//                 {summaryData.counts.caries["1"] || 0}
//               </span>
//             </li>
//             <li>
//               <span>2</span> Distinct Visual Change{" "}
//               <span className="code-count">
//                 {summaryData.counts.caries["2"] || 0}
//               </span>
//             </li>
//           </ul>
//           <p>
//             <strong>Moderate Caries</strong>
//           </p>
//           <ul>
//             <li>
//               <span>3</span> Localized Enamel Breakdown{" "}
//               <span className="code-count">
//                 {summaryData.counts.caries["3"] || 0}
//               </span>
//             </li>
//             <li>
//               <span>4</span> Underlying Dark Shadow{" "}
//               <span className="code-count">
//                 {summaryData.counts.caries["4"] || 0}
//               </span>
//             </li>
//           </ul>
//           <p>
//             <strong>Extensive Caries</strong>
//           </p>
//           <ul>
//             <li>
//               <span>5</span> Distinct Cavity{" "}
//               <span className="code-count">
//                 {summaryData.counts.caries["5"] || 0}
//               </span>
//             </li>
//             <li>
//               <span>6</span> Extensive Distinct Cavity{" "}
//               <span className="code-count">
//                 {summaryData.counts.caries["6"] || 0}
//               </span>
//             </li>
//           </ul>
//         </div>
//         <div className="legend-column mixed">
//           <div className="sub-box activity">
//             <h4>Lesion Activity</h4>
//             <ul>
//               <li>
//                 <span>+</span> Active{" "}
//                 <span className="code-count">
//                   {summaryData.counts.activity["+"] || 0}
//                 </span>
//               </li>
//               <li>
//                 <span>-</span> Inactive{" "}
//                 <span className="code-count">
//                   {summaryData.counts.activity["-"] || 0}
//                 </span>
//               </li>
//             </ul>
//           </div>
//           <div className="sub-box missing">
//             <h4>Teeth Missing Codes</h4>
//             <ul>
//               <li>
//                 <span>97</span> Missing due to caries{" "}
//                 <span className="code-count">
//                   {summaryData.counts.missing["97"] || 0}
//                 </span>
//               </li>
//               <li>
//                 <span>98</span> Missing for other reasons{" "}
//                 <span className="code-count">
//                   {summaryData.counts.missing["98"] || 0}
//                 </span>
//               </li>
//               <li>
//                 <span>99</span> Unrupted{" "}
//                 <span className="code-count">
//                   {summaryData.counts.missing["99"] || 0}
//                 </span>
//               </li>
//               <li>
//                 <span>P</span> Implant{" "}
//                 <span className="code-count">
//                   {summaryData.counts.missing["P"] || 0}
//                 </span>
//               </li>
//             </ul>
//           </div>
//         </div>
//         <div className="legend-column summary-values">
//           <h4>Summary</h4>
//           <div className="summary-item">
//             <span>Total # of Teeth assessed:</span>
//             <span className="summary-count main">
//               {summaryData.stats.assessed}
//             </span>
//           </div>
//           <div className="summary-item">
//             <span>Total # of Active Lesions:</span>
//             <span className="summary-count main">
//               {summaryData.stats.activeLesions}
//             </span>
//           </div>
//           <div className="summary-item">
//             <span>Total # of teeth with Caries:</span>
//             <span className="summary-count main">
//               {summaryData.stats.teethWithCaries}
//             </span>
//           </div>
//         </div>
//       </div>

//       {/* <div className="teeth-grid-container">
//         {ALL_TEETH_IDS.map((toothId) => (
//           <ToothSummaryCard
//             key={toothId}
//             toothId={toothId}
//             data={chartingData[toothId]}
//           />
//         ))}
//       </div> */}
// <div
//   style={{
//     display: "flex",
//     justifyContent: "flex-end",
//     marginBottom: "20px",
//   }}
// >
//   <button
//     className="view-full-chart-btn"
//     onClick={() => setShowPopup(true)}
//   >
//     View Full Dental Chart
//   </button>
// </div>

// <div className="teeth-grid-container">
// {TOOTH_ROWS.map((row, rowIndex) => (
//     <div key={rowIndex} className="tooth-row">
//       {row.map((toothId) => (
//         <ToothSummaryCard
//           key={toothId}
//           toothId={toothId}
//           data={chartingData[toothId]}
//         />
//       ))}
//     </div>
//   ))}
// </div>
      
// {showPopup && (
//   <div
//     className="full-chart-modal-overlay"
//     onClick={() => setShowPopup(false)}
//   >
//     <div
//       className="full-chart-modal-content"
//       onClick={(e) =>
//         e.stopPropagation()
//       }
//     >
//       {/* <button
//         className="close-chart-btn"
//         onClick={() =>
//           setShowPopup(false)
//         }
//       >
//         ✕
//       </button> */}

//       <div className="popup-chart-wrapper">

//         {POPUP_ROWS.map(
//           (row, rowIndex) => (
//             <div
//               key={rowIndex}
//               className="popup-row"
//             >
//               {row.map((toothId) => (
//                 <div
//                   key={toothId}
//                   className="popup-tooth-scale"
//                 >
//                   <ToothSummaryCard
//                     toothId={toothId}
//                     data={
//                       chartingData[toothId]
//                     }
//                   />
//                 </div>
//               ))}
//             </div>
//           )
//         )}

//       </div>
//     </div>
//   </div>
// )}
//       {/* ✅ NEW: Chart Legend */}
//       <div className="chart-legend">
//         {/* <span className="legend-title">Legends</span> */}

//         <div className="legend-item">
//           <span className="legend-color restoration-color"></span>
//           <span>Presence of Restoration or Sealants</span>
//         </div>

//         <div className="legend-item">
//           <span className="legend-color caries-color"></span>
//           <span>Presence and Severity of Caries Lesions</span>
//         </div>

//         <div className="legend-item">
//           <span className="legend-color activity-color"></span>
//           <span>Lesion Activity</span>
//         </div>

//         <div className="legend-item">
//           <span className="legend-color missing-color"></span>
//           <span>Teeth Missing</span>
//         </div>

//         <div className="legend-item">
//           <span className="legend-color summary-color"></span>
//           <span>Summary</span>
//         </div>
//       </div>

//       <div className="submission-buttons">
//         <button className="submit-btn" onClick={handleSubmit}>
//           Submit
//         </button>
//         <button className="reset-btn">Reset</button>
//       </div>
//     </div>
//   );
// };

// export default ChartingSummary;




// import React, { useMemo } from "react";
import React, {
  useMemo,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import "../../css/ChartingSummary.css";
import ToothSummaryCard from "./ToothSummaryCard";
import api from "../../api/axiosConfig";
import { ChartingState } from "../../pages/DentalChartingScreen";

interface ChartingSummaryProps {
  chartingData: ChartingState;
  onSubmitSuccess: () => void; // ✅ NEW
}

// const ALL_TEETH_IDS = [
//   55, 54, 53, 52, 51, 61, 62, 63, 64, 65, 85, 84, 83, 82, 81, 71, 72, 73, 74,
//   75,
// ];

const TOOTH_ROWS = [
  [55, 54, 53, 52, 51],
  [61, 62, 63, 64, 65],
  [85, 84, 83, 82, 81],
  [71, 72, 73, 74, 75],
];

const POPUP_ROWS = [
  [
    55,
    54,
    53,
    52,
    51,
    61,
    62,
    63,
    64,
    65,
  ],

  [
    85,
    84,
    83,
    82,
    81,
    71,
    72,
    73,
    74,
    75,
  ],
];

const ChartingSummary: React.FC<ChartingSummaryProps> = ({
  chartingData,
  onSubmitSuccess,
}) => {

  const [showPopup, setShowPopup] =
  useState(false);
  const { emrNumber } = useParams<{ emrNumber: string }>();
  const emrId = emrNumber;

  const summaryData = useMemo(() => {
    let activeLesions = 0;
    const teethWithCaries = new Set<string>();

    const codeCounts: {
      restoration: Record<string, number>;
      caries: Record<string, number>;
      activity: Record<string, number>;
      missing: Record<string, number>;
    } = {
      restoration: {
        "0": 0,
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
      },
      caries: { "0": 0, "1": 0, "2": 0, "3": 0, "4": 0, "5": 0, "6": 0 },
      activity: { "+": 0, "-": 0 },
      missing: { "97": 0, "98": 0, "99": 0, P: 0 },
    };

    for (const toothId in chartingData) {
      const tooth = chartingData[toothId];

      if (tooth.isMissing) {
        const code = tooth.missingCode || "P";
        codeCounts.missing[code] = (codeCounts.missing[code] || 0) + 1;
        continue;
      }

      for (const segment of Object.values(tooth.segments)) {
        if (segment.activity) {
          if (segment.activity === "+") activeLesions++;
          codeCounts.activity[segment.activity] =
            (codeCounts.activity[segment.activity] || 0) + 1;
        }

        if (segment.restoration) {
          codeCounts.restoration[segment.restoration] =
            (codeCounts.restoration[segment.restoration] || 0) + 1;
        }

        if (segment.caries) {
          if (parseInt(segment.caries, 10) > 0) {
            teethWithCaries.add(toothId);
          }
          codeCounts.caries[segment.caries] =
            (codeCounts.caries[segment.caries] || 0) + 1;
        }
      }
    }

    return {
      stats: {
        assessed: Object.keys(chartingData).length,
        activeLesions,
        teethWithCaries: teethWithCaries.size,
      },
      counts: codeCounts,
    };
  }, [chartingData]);

  const handleSubmit = async () => {
    if (!emrId) {
      alert("EMR ID missing");
      return;
    }

    try {
      await api.dataCollectionApi.post("/api/teledocs/dental/summary", {
        patientId: emrId,
        chartType: "primary",
        createdBy: "doctor_123",
        summaryData,
      });

      // ✅ MOVE TO TAB 3
      onSubmitSuccess();
    } catch (err) {
      console.error("Failed to save dental summary:", err);
      alert("Failed to save summary. Please try again.");
    }
  };

  return (
    <div className="summary-container">
      <h2 className="summary-main-title">Online Charting Summary</h2>
      <p className="summary-subtitle">
        This summary is automatically prepared after the online dental chart is
        submitted.
      </p>

      <div className="summary-legend-grid">
        {/* Legends with blue summary numbers */}
        <div className="legend-column restoration">
          <h4>Presence of Restoration or Sealants</h4>
          <ul>
            <li>
              <span>0</span> Not Restored or Sealed{" "}
              <span className="code-count">
                {summaryData.counts.restoration["0"] || 0}
              </span>
            </li>
            <li>
              <span>1</span> Sealant Partial{" "}
              <span className="code-count">
                {summaryData.counts.restoration["1"] || 0}
              </span>
            </li>
            <li>
              <span>2</span> Sealant Full{" "}
              <span className="code-count">
                {summaryData.counts.restoration["2"] || 0}
              </span>
            </li>
            <li>
              <span>3</span> Tooth Coloured Restoration{" "}
              <span className="code-count">
                {summaryData.counts.restoration["3"] || 0}
              </span>
            </li>
            <li>
              <span>4</span> Amalgam Restoration{" "}
              <span className="code-count">
                {summaryData.counts.restoration["4"] || 0}
              </span>
            </li>
            <li>
              <span>5</span> Stainless steel Crown{" "}
              <span className="code-count">
                {summaryData.counts.restoration["5"] || 0}
              </span>
            </li>
            <li>
              <span>6</span> Porcelain | Gold | etc.{" "}
              <span className="code-count">
                {summaryData.counts.restoration["6"] || 0}
              </span>
            </li>
            <li>
              <span>7</span> Lost or Broken Restoration{" "}
              <span className="code-count">
                {summaryData.counts.restoration["7"] || 0}
              </span>
            </li>
            <li>
              <span>8</span> Temporary Restoration{" "}
              <span className="code-count">
                {summaryData.counts.restoration["8"] || 0}
              </span>
            </li>
          </ul>
        </div>
        <div className="legend-column caries">
          <h4>Presence and Severity of Caries Lesions</h4>
          <p>
            <strong>Sound Surface</strong>
          </p>
          <ul>
            <li>
              <span>0</span> No evidence of caries{" "}
              <span className="code-count">
                {summaryData.counts.caries["0"] || 0}
              </span>
            </li>
          </ul>
          <p>
            <strong>Initial Caries</strong>
          </p>
          <ul>
            <li>
              <span>1</span> Initial Caries{" "}
              <span className="code-count">
                {summaryData.counts.caries["1"] || 0}
              </span>
            </li>
            <li>
              <span>2</span> Distinct Visual Change{" "}
              <span className="code-count">
                {summaryData.counts.caries["2"] || 0}
              </span>
            </li>
          </ul>
          <p>
            <strong>Moderate Caries</strong>
          </p>
          <ul>
            <li>
              <span>3</span> Localized Enamel Breakdown{" "}
              <span className="code-count">
                {summaryData.counts.caries["3"] || 0}
              </span>
            </li>
            <li>
              <span>4</span> Underlying Dark Shadow{" "}
              <span className="code-count">
                {summaryData.counts.caries["4"] || 0}
              </span>
            </li>
          </ul>
          <p>
            <strong>Extensive Caries</strong>
          </p>
          <ul>
            <li>
              <span>5</span> Distinct Cavity{" "}
              <span className="code-count">
                {summaryData.counts.caries["5"] || 0}
              </span>
            </li>
            <li>
              <span>6</span> Extensive Distinct Cavity{" "}
              <span className="code-count">
                {summaryData.counts.caries["6"] || 0}
              </span>
            </li>
          </ul>
        </div>
        <div className="legend-column mixed">
          <div className="sub-box activity">
            <h4>Lesion Activity</h4>
            <ul>
              <li>
                <span>+</span> Active{" "}
                <span className="code-count">
                  {summaryData.counts.activity["+"] || 0}
                </span>
              </li>
              <li>
                <span>-</span> Inactive{" "}
                <span className="code-count">
                  {summaryData.counts.activity["-"] || 0}
                </span>
              </li>
            </ul>
          </div>
          <div className="sub-box missing">
            <h4>Teeth Missing Codes</h4>
            <ul>
              <li>
                <span>97</span> Missing due to caries{" "}
                <span className="code-count">
                  {summaryData.counts.missing["97"] || 0}
                </span>
              </li>
              <li>
                <span>98</span> Missing for other reasons{" "}
                <span className="code-count">
                  {summaryData.counts.missing["98"] || 0}
                </span>
              </li>
              <li>
                <span>99</span> Unrupted{" "}
                <span className="code-count">
                  {summaryData.counts.missing["99"] || 0}
                </span>
              </li>
              <li>
                <span>P</span> Implant{" "}
                <span className="code-count">
                  {summaryData.counts.missing["P"] || 0}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="legend-column summary-values">
          <h4>Summary</h4>
          <div className="summary-item">
            <span>Total # of Teeth assessed:</span>
            <span className="summary-count main">
              {summaryData.stats.assessed}
            </span>
          </div>
          <div className="summary-item">
            <span>Total # of Active Lesions:</span>
            <span className="summary-count main">
              {summaryData.stats.activeLesions}
            </span>
          </div>
          <div className="summary-item">
            <span>Total # of teeth with Caries:</span>
            <span className="summary-count main">
              {summaryData.stats.teethWithCaries}
            </span>
          </div>
        </div>
      </div>

      {/* <div className="teeth-grid-container">
        {ALL_TEETH_IDS.map((toothId) => (
          <ToothSummaryCard
            key={toothId}
            toothId={toothId}
            data={chartingData[toothId]}
          />
        ))}
      </div> */}
<div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "20px",
  }}
>
  <button
    className="view-full-chart-btn"
    onClick={() => setShowPopup(true)}
  >
    View Full Dental Chart
  </button>
</div>

<div className="teeth-grid-container">
{TOOTH_ROWS.map((row, rowIndex) => (
    <div key={rowIndex} className="tooth-row">
      {row.map((toothId) => (
        <ToothSummaryCard
          key={toothId}
          toothId={toothId}
          data={chartingData[toothId]}
        />
      ))}
    </div>
  ))}
</div>
      
{showPopup && (
  <div
    className="full-chart-modal-overlay"
    onClick={() => setShowPopup(false)}
  >
    <div
      className="full-chart-modal-content"
      onClick={(e) =>
        e.stopPropagation()
      }
    >
      {/* <button
        className="close-chart-btn"
        onClick={() =>
          setShowPopup(false)
        }
      >
        ✕
      </button> */}

      <div className="popup-chart-scroll">
        <div className="popup-chart-wrapper">
          {POPUP_ROWS.map((row, rowIndex) => (
            <div key={rowIndex} className="popup-row">
              {row.map((toothId) => (
                <div key={toothId} className="popup-tooth-scale">
                  <ToothSummaryCard
                    toothId={toothId}
                    data={chartingData[toothId]}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
)}
      {/* ✅ NEW: Chart Legend */}
      <div className="chart-legend">
        {/* <span className="legend-title">Legends</span> */}

        <div className="legend-item">
          <span className="legend-color restoration-color"></span>
          <span>Presence of Restoration or Sealants</span>
        </div>

        <div className="legend-item">
          <span className="legend-color caries-color"></span>
          <span>Presence and Severity of Caries Lesions</span>
        </div>

        <div className="legend-item">
          <span className="legend-color activity-color"></span>
          <span>Lesion Activity</span>
        </div>

        <div className="legend-item">
          <span className="legend-color missing-color"></span>
          <span>Teeth Missing</span>
        </div>

        <div className="legend-item">
          <span className="legend-color summary-color"></span>
          <span>Summary</span>
        </div>
      </div>

      <div className="submission-buttons">
        <button className="submit-btn" onClick={handleSubmit}>
          Submit
        </button>
        <button className="reset-btn">Reset</button>
      </div>
    </div>
  );
};

export default ChartingSummary;
